import React, {PropTypes} from 'react';
import {connect} from 'react-redux';

import * as locations from '../../../../constants/dropdown';
import {messageTextValidation, nameValidation, emailValidation, phoneValidation} from '../../../../utils/itemValidation';

import * as commonActionCreators from '../../../../actions/common';
let allActionCreators = Object.assign({}, commonActionCreators);

import RhinoSelect from '../../../common/inputs/RhinoSelect';

class Spring2022 extends React.Component {

	static propTypes = {
    location: PropTypes.object
  };

  static contextTypes = {
    store: PropTypes.any,
    router: React.PropTypes.object.isRequired
  };

	constructor(props) {
		super(props);

		const firstEntryNotReq = [{display: 'Location', 'value': ''}];
    const finalEntry = [{display: 'Other', 'value': 'online@diamondsdirect.com'}];
    let newArray= firstEntryNotReq.concat(locations.locations).concat(finalEntry);

		this.state = {
			locations: newArray,
			inputName: '',
			inputEmail: '',
			inputPhone: '',
			inputLocation: '',
			inputMessage: '',
			inputDesigner: '',
			designerLocation: '',
			errorName: null,
			errorEmail: null,
			errorPhone: null,
			errorLocation: null,
			errorMessage: null,
			errorDesigner: null,
			errorDesignerLocation: null,
		};
	}

	internalNav(page) {
    this.context.router.push('/' + page);
  }

	externalNav(page) {
    window.location.href = '/' + page;
  }

  openNew(page) {
    let win = window.open(page, '_blank');
    win.focus();
  }

  changeName(evt) {
		this.setState({ inputName: evt.target.value }, () => {
			if(this.state.errorName && !nameValidation(this.state.inputName)) {
				this.setState({ errorName: null });
			}
		});
	}

	changeEmail(evt) {
		this.setState({ inputEmail: evt.target.value }, () => {
			if(this.state.errorEmail && !emailValidation(this.state.inputEmail)) {
				this.setState({ errorEmail: null });
			}
		});
	}

	changePhone(evt) {
		this.setState({ inputPhone: evt.target.value }, () => {
			if(this.state.errorPhone && !phoneValidation(this.state.inputPhone)) {
				this.setState({ errorPhone: null });
			}
		});
	}

	changeLocation(evt) {
		this.setState({ inputLocation: evt.target.value}, () => {
			if(this.state.errorLocation !== false && this.state.inputLocation !== '') {
				this.setState({errorLocation: null});
			}
		});
	}

	submitContactRequest() {
		if(this.validateAll()) {

			let contactData = {
				full_name: this.state.inputName,
				email: this.state.inputEmail,
				phone: this.state.inputPhone,
				location: this.state.inputLocation,
			}

			console.log(this.props);
			this.props.commonSummerContactRequest(contactData);
			// this.props.commonAlert('One of our diamond experts will be in touch shortly.', 'Continue');
			this.props.commonAlert('Thank you for submitting a request! A member of our team will follow up with you shortly.', 'Continue', 'helping', '');
			this.setState({
				inputName: '',
				inputEmail: '',
				inputPhone: '',
				inputLocation: '',
				inputDesigner: '',
				errorName: null,
				errorEmail: null,
				errorPhone: null,
				errorLocation: null,
			});
		}
	}

	validateAll() {

    let hasErrors = true;
    
    // Required params
    let nameError = nameValidation(this.state.inputName);
    let emailError = emailValidation(this.state.inputEmail);
    let locationError = nameValidation(this.state.inputLocation);

    // Optional params
    let phoneError = null;
    if(this.state.inputPhone) {
      phoneError = phoneValidation(this.state.inputPhone);
    }

    if(nameError === null &&
       emailError === null &&
       phoneError === null &&
       locationError === null) {
      hasErrors = false;
    }

    this.setState({
      errorName: nameError,
      errorEmail: emailError,
      errorPhone: phoneError,
      errorLocation: locationError,
    }, () => {
    	console.log(this.state);
    });

    return !hasErrors;
  }

	render() {
		return <div className='Spring2022'>
			<div className="promoBanner">
				<img className='desktop600' src="https://ddw2.diamondsdirect.com/img/promopages/spring2022/landing/landing_header_c.jpg" alt="Diamonds Direct" />
				<img className='mobile600' src="https://ddw2.diamondsdirect.com/img/promopages/spring2022/landing/landing_header_m_c.jpg" alt="Diamonds Direct" />
			</div>
			<div className='topSection'>
				<div className='topTitle'>Our Spring Style is in Full Bloom</div>
				<div className='topSubtitle' style={{display: 'none'}}>20% Spring Savings Event</div>
				<div className='topCopy'>
					<span style={{fontSize: '20px'}}>Shop Online Now!</span><br />
					Or visit us in-store for a Spring Event you don’t want to miss!<br />
					Enjoy 20% savings PLUS an expanded selection of designer jewelry,<br />
					expert-led guidance from our diamond consultants<br />
					and pop-ups from your favorite local businesses.<br /><br />
					Select the location nearest you for more information.
				</div>
			</div>
			<div className='blockSection' style={{ display: 'none' }}>
				<div className='blockSectionWrapper'>
					<div className={'blockItem fianceBlock'}>
						<div className='mainRow'>
							<div className={'mrBlock imgBlock'} onClick={() => this.internalNav('jewelry/BLDMD35086')}>
								<img src="https://ddw2.diamondsdirect.com/img/promopages/spring2022/landing/dateimage1.jpg" alt="Diamonds Direct Mothers Day" />
							</div>
							<div className={'mrBlock copyBlock rightCopy'}>
								<div className='mrBlockWrapper'>
									<div className='mrDate'>April 22 - 24</div>
									<div className='mrHr'></div>
									<div className='mrLinkWrapper'>
										<div className='mrLink' onClick={() => this.internalNav('charleston')}>Charleston, SC</div>
										<div className='mrSeparation'>|</div>
										<div className='mrLink' onClick={() => this.internalNav('oklahoma-city')}>Oklahoma City, OK</div>
										<br />
										<div className='mrLink' onClick={() => this.internalNav('virginia-beach')}>Virginia Beach, VA</div>
										<div className='mrSeparation'>|</div>
										<div className='mrLink' onClick={() => this.internalNav('indianapolis')}>Indianapolis, IN</div>
										<br />
										<div className='mrLink' onClick={() => this.internalNav('jacksonville')}>Jacksonville, FL</div>
										<div className='mrSeparation'>|</div>
										<div className='mrLink' onClick={() => this.internalNav('columbus')}>Columbus, OH</div>
										<br />
										<div className='mrLink' onClick={() => this.internalNav('kansas-city')}>Kansas City, KS</div>
										<div className='mrSeparation'>|</div>
										<div className='mrLink' onClick={() => this.internalNav('new-orleans')}>New Orleans, LA</div>
										<br />
										<div className='mrLink' onClick={() => this.internalNav('houston')}>Houston, TX</div>
										<div className='mrSeparation'>|</div>
										<div className='mrLink' onClick={() => this.internalNav('baybrook')}>Baybrook, TX</div>
										<br />
										<div className='mrLink' onClick={() => this.internalNav('pittsburgh')}>Pittsburgh, PA</div>
										<br />
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
			<div className='blockSection'>
				<div className='blockSectionWrapper'>
					<div className={'blockItem newlywedBlock'}>
						<div className='mainRow'>
							<div className={'mrBlock imgBlock mobileMakeup'} onClick={() => this.internalNav('setting/SMD1455201')}>
								<img src="https://ddw2.diamondsdirect.com/img/promopages/spring2022/landing/dateimage2.jpg" alt="Diamonds Direct Mothers Day" />
							</div>
							<div className={'mrBlock copyBlock'}>
								<div className='mrBlockWrapper'>
									<div className='mrDate'>April 29 - May 1</div>
									<div className='mrHr'></div>
									<div className='mrLinkWrapper'>
										<div className='mrLink' onClick={() => this.internalNav('charlotte')}>Charlotte, NC</div>
										<div className='mrSeparation'>|</div>
										<div className='mrLink' onClick={() => this.internalNav('birmingham')}>Birmingham, AL</div>
										<br />
										<div className='mrLink' onClick={() => this.internalNav('richmond')}>Richmond, VA</div>
										<div className='mrSeparation'>|</div>
										<div className='mrLink' onClick={() => this.internalNav('san-antonio')}>San Antonio, TX</div>
										<br />
										<div className='mrLink' onClick={() => this.internalNav('dallas')}>Dallas, TX</div>
										<div className='mrSeparation'>|</div>
										<div className='mrLink' onClick={() => this.internalNav('frisco')}>Frisco, TX</div>
										<div className='mrSeparation'>|</div>
										<div className='mrLink' onClick={() => this.internalNav('austin')}>Austin, TX</div>
										<br />
										<div className='mrLink' onClick={() => this.internalNav('st-louis')}>St. Louis, MO</div>
										<div className='mrSeparation'>|</div>
										<div className='mrLink' onClick={() => this.internalNav('cleveland')}>Cleveland, OH</div>
										<br />
										<div className='mrLink' onClick={() => this.internalNav('boca-raton')}>Boca Raton, FL</div>
										<div className='mrSeparation'>|</div>
										<div className='mrLink' onClick={() => this.internalNav('greenville')}>Greenville, SC</div>
										<br />
										<div className='mrLink' onClick={() => this.internalNav('raleigh')}>Raleigh, NC</div>
									</div>
								</div>
							</div>
							<div className={'mrBlock imgBlock rightImg'} onClick={() => this.internalNav('setting/SMD1455201')}>
								<img src="https://ddw2.diamondsdirect.com/img/promopages/spring2022/landing/dateimage2.jpg" alt="Diamonds Direct Mothers Day" />
							</div>
						</div>
					</div>
				</div>
			</div>
			<div className='midBlock'>
				<div className='midBlockCopy'>With so much to choose from, here are some of our freshest picks for you:</div>
				<div className='midBlockButtons'>
					<div className='midBlockButton' onClick={() => this.internalNav('gallery/engagement-rings?mode=setting')}>Shop<br />Engagement Rings</div>
					<div className='midBlockButton' onClick={() => this.internalNav('gallery/fine-jewelry?type=ring')}>Shop<br />Trending Jewelry</div>
					<div className='midBlockButton' onClick={() => this.internalNav('diamond-studs')}>Shop<br />Diamond Studs</div>
				</div>
			</div>
			<div className='formBoxWrapper'>
				<div className='formInnerWrapper'>
					
					<div className='formP'>Looking for something? We’ll connect you with an expert nearest you!</div>

					<div className='formWrapper'>
						<div className='formInputWrapper'>
							<input 
								className={this.state.errorName ? 'textInput error' : 'textInput'}
								type='text' 
								placeholder='Full Name*'
								value={this.state.inputName}
              					onChange={::this.changeName} />
						</div>
						<div className='formInputWrapper'>
							<input 
								className={this.state.errorEmail ? 'textInput error' : 'textInput'}
								type='email' 
								placeholder='Email Address*'
								value={this.state.inputEmail}
              					onChange={::this.changeEmail} />
						</div>
						<div className='formInputWrapper'>
							<input 
								className={this.state.errorPhone ? 'textInput error' : 'textInput'}
								type='text' 
								placeholder='Telephone'
								value={this.state.inputPhone}
              					onChange={::this.changePhone} />
						</div>
						<div className='formInputWrapper'>
							<RhinoSelect
				                selectClass={'summerSelect'}
				                required={true}
				                value={this.state.inputLocation}
				                options={this.state.locations}
				                changeMethod={(evt) => this.changeLocation(evt)}
				                error={this.state.errorLocation !== null} />
						</div>
						<div className='formActionRow'>
							<button className={'formAction'} onClick={::this.submitContactRequest}>Request an appointment</button>
						</div>
					</div>
				</div>
			</div>
			<div className='copySection'>
				Missed your local showroom’s event? Enjoy 20% savings online now!
			</div>
			<div className='cheersBlock'>
				<div className='cheersBlockWrapper'>
					<div className={'itemRow cbItems'} style={{marginBottom: '25px'}}>
						<img className='desktop600' src="https://ddw2.diamondsdirect.com/img/promopages/spring2022/landing/collagea.jpg" alt="Diamonds Direct" />
						<img className='mobile600' src="https://ddw2.diamondsdirect.com/img/promopages/spring2022/landing/collagea_m.jpg" alt="Diamonds Direct" />
						<div className={'cbiLink cbiLeft'} onClick={() => this.internalNav('jewelry/NCOST07518')}></div>
						<div className={'cbiLink cbiTopLeft'} onClick={() => this.internalNav('jewelry/ECLST08000')}></div>
						<div className={'cbiLink cbiTopRight'} onClick={() => this.internalNav('jewelry/BLDMD35086')}></div>
						<div className={'cbiLink cbiBottomMiddle'} onClick={() => this.internalNav('jewelry/E4FAN00077')}></div>
						<div className={'cbiLink cbiRight'} onClick={() => this.internalNav('setting/SMD1455963')}></div>
					</div>
				</div>
			</div>	
			<div className='legalRow'>*Discount excludes certified diamonds and price-protected lines. Cannot be combined with other offers.</div>		
		</div>;
	}
}
export default Spring2022;

function mapStateToProps(state) {
  return {

  };
}

export const Spring2022Container = connect(
  mapStateToProps,
  allActionCreators
)(Spring2022);


// WEBPACK FOOTER //
// ./src/components/views/promopages/spring2022/Spring2022.jsx